import React, { useEffect, useState } from "react";
import "./index.css";
import { AuthProvider, useAuth } from "./lib/AuthContext";
import AuthPage   from "./pages/AuthPage";
import WalletPage from "./pages/WalletPage";
import { reattachPendingHolds } from "./lib/db";  // ✅ NEW

function Splash() {
  return (
    <div className="hero-grad" style={{ minHeight:"100vh", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", fontFamily:"'Outfit',sans-serif" }}>
      <div style={{ width:76, height:76, background:"linear-gradient(135deg,#0A0F1E,#1B2A5B)", border:"1px solid rgba(255,255,255,.14)", borderRadius:24, display:"flex", alignItems:"center", justifyContent:"center", marginBottom:24, boxShadow:"0 18px 44px rgba(0,0,0,.45)" }}>
        <span style={{ fontSize:34, color:"#fff" }}>✦</span>
      </div>
      <p style={{ fontSize:44, fontWeight:900, letterSpacing:-2.5, color:"#fff" }}>xylo<span style={{ color:"#7EE2B8", fontWeight:600 }}>pay</span></p>
      <p style={{ fontSize:11, color:"#7EE2B8", letterSpacing:3.5, marginTop:10, fontWeight:800 }}>SECURE DIGITAL WALLET</p>
      <div style={{ display:"flex", gap:7, marginTop:48 }}>
        {[0,1,2].map(i=>(
          <div key={i} style={{ width:7, height:7, borderRadius:"50%", background:"#7EE2B8", opacity:0.25+i*0.35, animation:`pulse 1.4s ${i*0.28}s infinite` }}/>
        ))}
      </div>
    </div>
  );
}

function OfflineBanner() {
  const [offline, setOffline] = useState(!navigator.onLine);
  useEffect(() => {
    const on  = () => setOffline(false);
    const off = () => setOffline(true);
    window.addEventListener("online",  on);
    window.addEventListener("offline", off);
    return () => { window.removeEventListener("online", on); window.removeEventListener("offline", off); };
  }, []);
  if (!offline) return null;
  return (
    <div style={{ position:"fixed", top:0, left:0, right:0, background:"#111", color:"#fff", textAlign:"center", padding:"10px", fontSize:13, fontFamily:"'Outfit',sans-serif", zIndex:9999 }}>
      ⚡ No internet connection — reconnecting...
    </div>
  );
}

function AppRouter() {
  const { firebaseUser, loading, profile } = useAuth();

  // ✅ Re-attach hold timers every time user loads the app
  // This ensures holds still release even after page refresh
  useEffect(() => {
    if (firebaseUser && profile?.id) {
      reattachPendingHolds(profile.id, profile.name || "Someone");
    }
  }, [firebaseUser, profile?.id]);

  if (loading) return <Splash/>;
  if (firebaseUser) return <WalletPage/>;
  return <AuthPage/>;
}

export default function App() {
  return (
    <AuthProvider>
      <OfflineBanner/>
      <AppRouter/>
    </AuthProvider>
  );
}
